module.exports = __webpack_public_path__ + "img/icon-white-19.85e68ca1.svg";